export const COLORS = [
    "rgb(85, 196, 209)", // Pastel Teal
    "rgba(255, 128, 114, 1)", // Pastel Red-Orange
    "rgb(183, 183, 183)", // Pastel Grey
    "rgb(86, 183, 99)", // Pastel dark green
    "#FF33A1", // Pink
    "#FFBD33", // Yellow
    "#8D33FF",  // Purple
];